import React from 'react';
import {Helmet} from 'react-helmet';
import { store } from '../../../store';

import Tasknav from '../Tasknav'

import Save from '../Save'

import AboutSection from '../Sections/About/AboutSection'

import Profile from '../Sections/Profile/Profile'

import CustomizationPanel from '../Sections/Customization/CustomizationPanel'

import Controller from '../Sections/Customization/Controller'

import LinksFunction from '../Sections/SocialLinks/LinksFunction'
import LinksSection from '../Sections/SocialLinks/LinksSection'

import ImageUploadFunction from '../Sections/Images/ImageUploadFunction'
import {ProPic, CoverImageURL} from '../Sections/Images/ImageSection'

import Menu from '../../Navigation/Menu'

const Second = ({onUser, onEdit, onOpen, onRouteChange, onWebsitename, onWebsiteBio, onCustomization, onSelectToolbar, onHighlight, onMenu, highlight, menu, handleOffClick, onClickInside, onClickOutside, onController, controller, profile_name, profile_bio, about, icons, background,onOuterDiv,onInnerDiv, outerdiv}) => {

  return ( 
<div id="scroll" className="editSection">          
<Helmet>
<meta name="viewport" content="width=device-width,initial-scale=1" />
<link href="https://fonts.googleapis.com/css?family=Coiny:400,700,700i|Dancing+Script:400,700,700i|Indie+Flower:400,700,700i|Lato:400,700,700i|Lobster+Two|Merriweather:400,700,700i|Open+Sans:400,700,700i|Pacifico:400,700,700i|Righteous:400,700,700i|Shadows+Into+Light+Two|Lora:400,700|Vibur:400,700,700i|Oswald:400,700|Roboto+Mono:400,700|Roboto:400,700,900|Abel" rel="stylesheet" />
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
<style type="text/css">{`
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
body{
  animation: .5s ease-in-out 0s 1 fadeIn;
  margin:0;
  padding: 0;
  max-width: 100%;
  overflow-x: hidden;
}
body::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
}
body::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius:3px;
}
.bg {
  background:${background.color};
  width:100vw;
}
.wrap {
  width:100vw;
  margin:0;
  padding: 0;
  min-height:100vh;
  opacity:1;
}
.cover {
  width:100vw;
  height:100vh;
  background: url(${CoverImageURL()});
  background-attachment: fixed;
  background-position:center;
  background-size:cover;
  opacity:${background.opacity};
  position:fixed;
}

.main {
  width: 100%;
  display:flex;
  justify-content: center;
  align-items: center;
  margin:0 auto;
  padding:3em 0;
  min-height:80vh;
  opacity:1;
}
.about {
	padding:0.5em;
	z-index:1;
	width: 90.5%;
	font-family: ${about.font};
	color:${about.color};
	font-size:${about.size}px;
	text-align:center;
}
.paragraph,
p {
font-family: ${about.font};
color:${about.color};
margin-bottom:1em;
font-size:${about.size}px;
line-height:1.8;
}
p a {
text-decoration:underline;
color:${about.color};
}
p a:hover {
text-decoration:underline;
color:${about.color};
}

.profile-card {
  animation: 1s ease-in-out 0s 1 fadeIn;
  background: transparent;
  margin:0 auto;
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}

.profile {
padding: 1.2em 0;
display: flex;
justify-content:center;
align-items: center;
align-content:flex-start;
z-index:1;
}
.profile_pic {
min-width:100px;
width: 150px;
height: 150px;
margin:0 1.2em 0 0;
border-radius: 100px;
overflow:hidden;
}
.dp {
width: 100%;
height: 100%;
object-fit: cover;
transition:.25s;
}
.profile_name {
font-family:${profile_name.font};
font-weight: 700;
text-transform: capitalize;
font-size:${profile_name.size}px;
display: block;
color:${profile_name.color};
}
.profile_desc {
font-family:${profile_bio.font};
color:${profile_bio.color};
font-size:${profile_bio.size}px;
}
.socialicon {
color: ${icons.color};
font-size: 22px;
margin:0.2em .2em 0em 0em;
transition: .25s;
}
.socialicon:hover {
color: ${icons.color};
}
.credits {
	padding:1.5em;
	font-family: roboto;
	font-weight: 900;
}
@media only screen and (min-width : 1200px) {
.main {
  width: 50%;
  min-height:100vh;
  justify-content: center;
  align-items: center;
  background:transparent;
}
}
`}</style>
</Helmet>
{(store.getState().activities.edit)         
? <div className="toptoolbar">
	<Tasknav
	onRouteChange={onRouteChange}
	onEdit={onEdit}
	onOpen={onOpen}
	onHighlight={onHighlight}
	highlight={highlight}
	onClickInside={onClickInside}
    onClickOutside={onClickOutside}
	/><span className="navmargin"><br /><br /><br /></span></div>
: null
}
<div className="bg">
{(store.getState().activities.edit)  
? <span onClick={
  (open,select)=>
  {
  if(store.getState().activities.edit && outerdiv) {
  onOpen('cover')
  }
  }}  className="img_edit_cover"><i class="fa fa-camera img_edit_cover_icon" aria-hidden="true"></i> Upload</span>
: null
}
<div className="cover">
</div>
<div className='wrap'>
<div className="main">
<div>
<div className="profile-card"
onMouseOver = {onInnerDiv.bind()}
onMouseOut = {onOuterDiv.bind()}>
<div className="profile">
{(store.getState().activities.edit)  
? <div className="profile_pic">
  <div className="dp select" onClick={(open)=>
  {
  onOpen('propic')
  }}><i class="fa fa-camera img_edit_top_dp" aria-hidden="true"></i><img alt="dp" src={ProPic()} className="dp"/></div>
  </div>
: ProPic() !== null
  ? <div className="profile_pic">
    <img alt="dp" src={ProPic()} className="dp"/>
    </div>
  : null
}
<div className={
	store.getState().activities.edit
	? 'select_col'
	: ''
}>
<Profile onWebsitename={onWebsitename} onWebsiteBio={onWebsiteBio} onHighlight={onHighlight} highlight={highlight} />
<Controller
	onOpen={onOpen}
	onSelectToolbar={onSelectToolbar}
/>
<div className="social_media">
<LinksFunction 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>        
<LinksSection onOpen={onOpen}/>
{(store.getState().activities.edit) 
? <span class="fa fa-plus addnew socialicon" onClick={(open)=>{onOpen('links')}}></span>
: null
}
</div>
</div>
</div>
<div className={
	store.getState().activities.edit
	? 'about select_col'
	: 'about'
}>
<AboutSection/>
</div>
</div>
</div>
</div>
</div>
</div>
{highlight === 'save'     
? <Save onHighlight={onHighlight} />
: null
}
{(!store.getState().activities.edit)         
?<span className="editbtn" onClick={(edit,open)=>{
onEdit(true)
onOpen(null)
onHighlight(null)
}}>Edit</span>
:<span />
}
{store.getState().activities.open === 'menu'
? <Menu
	onOpen={onOpen}
	onRouteChange={onRouteChange} 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>
: null
}
<CustomizationPanel 
	onEdit={onEdit}
	onOpen={onOpen}
	onSelectToolbar={onSelectToolbar}
	onCustomization={onCustomization}
	onClickInside={onClickInside}
    onClickOutside={onClickOutside} />
<ImageUploadFunction 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>
</div>
  )
}

export default Second